<template>
    <v-card elevation="1" class="buscador-container">
        <v-card-text v-if="tipoEstudiante != 1">
            <v-chip  color="#002245" text-color="white" class="ml-9" label>
                <v-icon left>mdi-information</v-icon>
                {{ tipoEstudiante === 2 ? 'HOMOLOGADO' : (tipoEstudiante === 3 || tipoEstudiante === 4) ? 'CONVALIDADO'
                    : '' }}
            </v-chip>
        </v-card-text>
        <v-form ref="form" lazy-validation>
            <v-container>
                <v-row no-gutters class="mb-2">
                    <v-col cols="12" :md="ocultarFoto ? 9 : 5">
                        <v-btn outlined color="#002245" height="56" class="selector-btn mb-4" @click="showBuscarEstudiante()" title="BUSCAR ESTUDIANTE" block>
                          <v-icon color="#002245">mdi-gesture-double-tap</v-icon>
                          <span class="selector-btn__text">
                            <span class="selector-btn__label">ESTUDIANTE</span>
                            <span class="selector-btn__value">{{ nombreCompletoConAgregado || "BUSCAR ESTUDIANTE" }}</span>
                          </span>
                        </v-btn>
                        <div class="selector-btn selector-btn--static">
                          <v-icon color="#002245">mdi-school-outline</v-icon>
                          <span class="selector-btn__text">
                            <span class="selector-btn__label">CARRERA</span>
                            <span class="selector-btn__value">{{ carrera || "SIN CARRERA" }}</span>
                          </span>
                        </div>
                    </v-col>
                    <v-col cols="12" md="2" v-if="!ocultarFoto"></v-col>

                    <v-col cols="12" md="2" v-if="!ocultarFoto">

                        <v-card class="mx-auto" color="#EEEEEE" dark max-width="183" elevation="5" outlined shaped>
                            <v-list-item class="grow">
                                <v-list-item-avatar color="#FFFFFF" size="150
                                                                        ">
                                    <v-img class="elevation-6" alt="" :src="urlFoto"></v-img>
                                </v-list-item-avatar>
                            </v-list-item>

                        </v-card>
                    </v-col>

                </v-row>
                <v-row no-gutters>
                    <slot></slot>
                </v-row>
            </v-container>
        </v-form>

    </v-card>
</template>

<script>
import axios from "axios";
/**
 * @props {Boolean} clearData - Indica si se debe limpiar la información del estudiante seleccionado.
 * @emits {seleccionarEstudiante(item)} - Evento emitido cuando se selecciona un estudiante, contiene la información del estudiante seleccionado.
 * @slot {default} - Contenido adicional que se puede insertar en el componente.
 */
export default {
    props: {
        clearData: {
            type: Boolean,
            required: false,
            default: false,
        },
        ocultarFoto: {
            type: Boolean,
            required: false,
            default: false,
        },
        idSede: {
            type: [Number, String],
            required: false,
            default: null,
        },
    },
    emits: ['seleccionarEstudiante'],

    data() {
        return {
            id_sede: 1,
            sede: '',
            usuario: '',
            nomus: '',
            nombreCompleto: '',
            elModal: '',
            uniest: '',
            mat: '',
            pat: '',
            carrera: '',
            carreraModal: false,
            nomest: '',
            elModal: false,
            urlFoto: '',
            tipoEstudiante: 1,

            headersCarrera: [{
                text: "CARRERA",
                value: "carre",
                sortable: true
            },
            {
                text: "OPCIONES",
                value: "actions",
                sortable: false
            },
            ],
            datosEstudiante: [],
            datosCarrera: [],
            snackbarOK: false,
            mensajeSnackbar: '',
            datossede: [],
            alertsede: {},

        }
    },

    computed: {
        nombreCompletoConAgregado() {
            let added = '';
            console.log("TIPO ESTUDIANTE: " + this.tipoEstudiante);
            if (this.tipoEstudiante === 2) {
                added = ' (HOMOLOGADO)';
            } else if (this.tipoEstudiante === 3 || this.tipoEstudiante === 4) {
                added = ' (CONVALIDADO)';
            }
            return this.nombreCompleto + added;
        },
        user() {
            return this.$store.getters.user;
        },
        sedeEfectiva() {
            return this.idSede != null && this.idSede !== '' ? this.idSede : this.id_sede;
        },
    },


    methods: {
        seleccionarEst(item) {
            console.log("Buscador seleccionando estudiante");
            this.urlFoto = item.urlimage;
            this.nombreCompleto = item.nom + " " + item.pat + " " + item.mat;
            item.nombreCompleto = this.nombreCompleto;
            this.carrera = item.carrer;
            this.tipoEstudiante = item.tpestu;
            this.$emit('seleccionarEstudiante', item);
            this.elModal = false;
        },

        showBuscarEstudiante() {
            this.$store.dispatch('openModal', {
                component: 'BuscadorModal',
                props: { title: 'Buscar Estudiante', idSede: this.sedeEfectiva, style: { width: '1200px', padding: '2rem' } },
                events: { seleccionarEstudiante: this.seleccionarEst }
            });
        },




        limpiarApell() {
            this.pat = "";
            this.mat = "";
            this.uniest = "";
        },
        async listarsede() {
            let me = this;
            await axios
                .get("/reporte/sedes")
                .then(function (response) {
                    if (response.data.resultado == null) {
                        me.datossede = [];
                        me.alertsede = {
                            show: true,
                            type: "error",
                            message: "NO EXISTEN DATOS:(",
                        };
                    } else {
                        //console.log(response.data);
                        me.datossede = response.data.resultado;
                        me.alertsede = {
                            show: false,
                            type: "",
                            message: ""
                        };
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        cleanData() {
            this.nombreCompleto = '';
            this.carrera = '';
            this.urlFoto = '';
            this.carrera = '';
        },
    },
    watch: {
        clearData(state) {
            this.cleanData();
        }
    },

    created: function () {
        this.usuario = this.user.personal;
        this.id_sede = this.user.id_sede;
        console.log(this.user.id_sede);
        this.sede = this.user.sede;
        this.nomus =
            this.user.nombres + " " + this.user.paterno + " " + this.user.materno;
        this.listarsede();
    },
}
</script>


<style scoped>
    .buscador-container {
        padding-left: 4.5rem ;
    }

    .selector-btn {
      border-width: 1.5px !important;
      border-radius: 8px !important;
      justify-content: flex-start !important;
      text-transform: none !important;
    }
    .selector-btn--static {
      display: flex;
      align-items: center;
      height: 56px;
      border: 1.5px solid rgba(0, 34, 69, 0.35);
      border-radius: 8px;
      padding: 0 16px;
      background-color: #fafbfc;
    }
    .selector-btn__text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 8px;
      line-height: 1.2;
      min-width: 0;
      max-width: 100%;
    }
    .selector-btn__label {
      font-size: 0.73rem;
      font-weight: 600;
      color: #55606e;
    }
    .selector-btn__value {
      font-size: 0.85rem;
      font-weight: 700;
      color: #002245;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
</style>
